import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

// Import Routes
import { authProtectedRoutes, publicRoutes } from './routes';
import AppRoute from './routes/route';

// layouts
import VerticalLayout from './components/VerticalLayout';
import NonAuthLayout from './components/NonAuthLayout';

// Import ScannerProvider
import ScannerProvider from './utilities/ScannerContext';

// Import scss
import './assets/scss/theme.scss';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const Layout = this.getLayout();

    return (
      <ScannerProvider>
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={route.layout ? route.layout : NonAuthLayout}
                component={route.component}
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                isAuthProtected={false}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={route.layout ? route.layout : Layout}
                component={route.component}
                allowedRoles={route.allowedRoles}
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                isAuthProtected
                exact
              />
            ))}
          </Switch>
        </Router>
      </ScannerProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

App.propTypes = {
  // eslint-disable-next-line react/require-default-props
  layout: PropTypes.object,
};

export default connect(mapStateToProps, null)(App);
